import { ReactNode } from 'react';
import { Divider } from '@screentone/core';

import styles from './BlockDividerButton.module.scss';

interface BlockDividerButtonProps {
  open?: boolean;
  children: ReactNode;
}

export const BlockDividerButton = ({ open, children }: BlockDividerButtonProps) => (
  <div className={styles.blockDivider}>
    <div className={`${styles.blockDividerContent}${open ? ` ${styles.open}` : ''}`}>
      <Divider className={styles.blockDividerDivider} />
      {children}
      <Divider className={styles.blockDividerDivider} />
    </div>
  </div>
);
